import {call, put, takeLatest} from 'redux-saga/effects';
import {
  getFinancePaymentsRequest,
  getFinancePaymentsSuccess,
  getFinancePaymentsFailure,
  refundPaymentRequest,
  refundPaymentSuccess,
  refundPaymentFailure,
  getSpecialistPayoutsRequest,
  getSpecialistPayoutsSuccess,
  getSpecialistPayoutsFailure,
  changePayoutStatusRequest,
  changePayoutStatusSuccess,
  changePayoutStatusFailure,
} from '../slices/financeAdminSlice';

import {getFinancePayments, refundPayment, getSpecialistPayouts, changePayoutStatus} from '@/services/api';
import {SUCCESS_KEY} from '@/constants';

function* getFinancePaymentsSaga(action: any): Generator {
  try {
    const response: any = yield call(getFinancePayments, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getFinancePaymentsSuccess(response.data));
    } else {
      yield put(getFinancePaymentsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getFinancePaymentsFailure(error.response || error));
  }
}

function* refundPaymentSaga(action: any): Generator {
  try {
    const response: any = yield call(refundPayment, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(refundPaymentSuccess(response.data));
    } else {
      yield put(refundPaymentFailure(response.data));
    }
  } catch (error: any) {
    yield put(refundPaymentFailure(error.response || error));
  }
}

function* getSpecialistPayoutsSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistPayouts, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistPayoutsSuccess(response.data));
    } else {
      yield put(getSpecialistPayoutsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistPayoutsFailure(error.response || error));
  }
}

function* changePayoutStatusSaga(action: any): Generator {
  try {
    const response: any = yield call(changePayoutStatus, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(changePayoutStatusSuccess(response.data));
    } else {
      yield put(changePayoutStatusFailure(response.data));
    }
  } catch (error: any) {
    yield put(changePayoutStatusFailure(error.response || error));
  }
}

export default function* financeAdminSaga(): Generator {
  yield takeLatest(getFinancePaymentsRequest.type, getFinancePaymentsSaga);
  yield takeLatest(refundPaymentRequest.type, refundPaymentSaga);
  yield takeLatest(getSpecialistPayoutsRequest.type, getSpecialistPayoutsSaga);
  yield takeLatest(changePayoutStatusRequest.type, changePayoutStatusSaga);
}

